import echarts from 'echarts';

export default function baseEcharts(element, optionData) {
  const chart = echarts.init(document.getElementById(element));
  chart.clear();
  chart.setOption(optionData);
}


// WEBPACK FOOTER //
// ./src/components/ProductDetails/mod_screen_display_show/components/BaseEcharts.js